import {clsx} from 'clsx'

import {TEST_IDS} from '../../constants/test-ids'
import styles from './ComposerResizeHandle.module.css'

type ComposerResizeHandleProps = {
  isResizing: boolean
  handleProps: React.ComponentPropsWithoutRef<'div'>
}

/** Centered grab handle on the top edge of the sticky composer used to resize it. */
export function ComposerResizeHandle({isResizing, handleProps}: ComposerResizeHandleProps) {
  return (
    <div
      {...handleProps}
      className={clsx(styles.handle, isResizing && styles.resizing)}
      // Stable hook for the header-hover reveal selector in IssueCommentComposer.module.css,
      // kept separate from data-testid so styling isn't coupled to the test id.
      data-composer-resize-handle=""
      data-testid={TEST_IDS.resizeHandle}
    />
  )
}
